import costuto from '@/apis/costuto.js'

const actions = {
  index: (context) => {
    return new Promise((resolve, reject) => {
      costuto().get('article_topics')
        .then(resp => {
          resolve(resp)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

export default {
  namespaced: true,
  actions
}
